import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_infinite_loading = _resolveComponent("infinite-loading", true)!

  return (_openBlock(), _createBlock(_component_infinite_loading, {
    onInfinite: _ctx.infiniteHandler,
    class: "p-text-center"
  }, {
    spinner: _withCtx(() => [
      _createVNode(_component_ProgressSpinner, {
        style: {"width":"40px","height":"40px"},
        strokeWidth: "5",
        fill: "#ffffff",
        animationDuration: ".8s"
      })
    ]),
    "no-more": _withCtx(() => [
      _hoisted_1
    ]),
    "no-results": _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }, 8, ["onInfinite"]))
}